import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

// Real backend: POST /:id/allocations/:allocationId/return — body: { returnNotes } ONLY.
// The backend sets actual_return = new Date() itself (server time), so there's
// no "return date" field to send — the controller only reads req.body.returnNotes.
export const returnAsset = createAsyncThunk("returnAsset", async ({ assetId, allocationId, data }) => {
	const response = await axiosHttp.post(`assets/${assetId}/allocations/${allocationId}/return`, {
		returnNotes: data.returnNotes,
	});
	message.success("Asset returned successfully!");
	return response.data?.data ?? response.data;
});

const AllocationReturnSlice = createSlice({
	name: "allocationReturnSlice",
	initialState: { isLoading: false, error: null },
	extraReducers: (builder) => {
		builder.addCase(returnAsset.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(returnAsset.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(returnAsset.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default AllocationReturnSlice.reducer;
